import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';

export const ShopItemsContainer = styled.div<{ isNotNeedCarousel?: boolean }>`
    gap: 4px;
    min-height: 176px;
    align-content: flex-start;
    margin-bottom: auto;
    ${({ isNotNeedCarousel }) => isNotNeedCarousel && 'padding: 0 16px;'}

    @media (max-width: ${wideBreakpoints.laptop}) {
        min-height: auto;
    }
`;
